import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';

import { AppRoutingModule, routes } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { DatePipe } from '@angular/common';
import {ToastrModule} from 'ngx-toastr';
import {Ng2TelInputModule} from 'ng2-tel-input';

// import { QRCodeModule } from 'angular2-qrcode';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    Ng2TelInputModule,
    ToastrModule.forRoot(),
    //QRCodeModule,
    RouterModule.forRoot(routes, {useHash: false, scrollPositionRestoration: 'enabled'}),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA],
  providers: [DatePipe],
  
  bootstrap: [AppComponent]
})
export class AppModule { }
